import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export function showNotification({ title, html, didOpen, ...rest }) {
  return MySwal.fire({
    title,
    html,
    didOpen,
    ...rest,
  });
}

// برای استفاده:
// import { showNotification } from "./Notification";
// showNotification({ title: <p>سلام دنیا</p> });
//
// می‌تونی پراپرتی‌های sweetalert2 رو هم بهش بدی
